/**
 * Module dependencies.
 */

import { resolve } from 'url';

/**
 * Export `absoluteUrlResolve` util.
 */

export function absoluteUrlResolve(path: string): string {
  return resolve(process.env.NEXT_PUBLIC_BASE_URL as string, path);
}
